import { render, staticRenderFns } from "./xlsxImport.vue?vue&type=template&id=13dc4a0a&scoped=true&"
import script from "./xlsxImport.vue?vue&type=script&lang=js&"
export * from "./xlsxImport.vue?vue&type=script&lang=js&"
import style0 from "./xlsxImport.vue?vue&type=style&index=0&id=13dc4a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc4a0a",
  null
  
)

export default component.exports